import api from "./api";

const referralService = {
  getStats: async () => {
    try {
      const response = await api.get("/referral/stats");
      return response;
    } catch (error) {
      console.error("Error fetching referral stats:", error);
      throw error;
    }
  },

  getLeaderboard: async (type: string = "volume", limit: number = 50) => {
    try {
      const response = await api.get(
        `/referral/leaderboard?type=${type}&limit=${limit}`,
      );
      return response;
    } catch (error) {
      console.error("Error fetching leaderboard:", error);
      throw error;
    }
  },

  getReferralTree: async () => {
    try {
      const response = await api.get("/referral/tree");
      return response;
    } catch (error) {
      console.error("Error fetching referral tree:", error);
      throw error;
    }
  },

  getEarningsHistory: async (page: number = 1, perPage: number = 20) => {
    try {
      const response = await api.get(
        `/referral/earnings-history?page=${page}&per_page=${perPage}`,
      );
      return response;
    } catch (error) {
      console.error("Error fetching earnings history:", error);
      throw error;
    }
  },

  sendInvite: async (email: string, message?: string) => {
    try {
      const response = await api.post("/referral/invite", { email, message });
      return response;
    } catch (error) {
      console.error("Error sending invite:", error);
      throw error;
    }
  },
};

export default referralService;
